import styled from 'styled-components';
import { getSpace, px2rem, mq } from '../../../../stylesheets/tools';

const StyledEducationCollectionBar = styled.section`
  .collection-bar {
    display: flex;
    padding: ${getSpace('s')} 0 0 0;
    gap: ${px2rem('20px')};
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;

    ${mq('m')} {
      padding: ${getSpace('l')} 0 0 0;
    }
    .collection-bar__link {
      display: flex;
      align-items: center;
      gap: 8px;
      text-transform: uppercase;

      svg {
        height: 15px;
      }
    }
  }
`;

export default StyledEducationCollectionBar;
